import dayjs from "dayjs" 

export interface IDateRange {
    from?: Date
    to?: Date
    isValid(): boolean,
    isEmpty(): boolean,
    toString(): string
}
export class DateRange implements IDateRange {
    public from?: Date
    public to?: Date

    constructor(range?: IDateRange) {
        this.from = range?.from ?? undefined;
        this.to = range?.to ?? undefined;
    }

    isEmpty(): boolean {
        return this.from === undefined && this.to === undefined;
    }

    isValid() : boolean {
        return this.from !== undefined && this.to !== undefined ? this.from <= this.to : true;
    }

    toString(format: string = 'MM/DD/YYYY') : string {
        const sb = [];
        if (this.from !== undefined) {
            sb.push(dayjs(this.from).format(format));
        }
        if (this.to !== undefined) {
            if (this.from !== undefined) {
                sb.push('to')
            }
        }
        return sb.join(' ');
    }
}
